import { aanmeldingenState } from './aanmeldingen.state.js'
import { normalizeAanmeldingen } from './aanmeldingen.normalizers.js'
import { normalizeVliegers } from '../persist/persist.normalizers.js'
import { createSelector } from 'reselect'

export const aanmeldingenReducer = (state = aanmeldingenState, action) => {
  switch (action.type) {
    case 'AANMELDING_PENDING':
      return {
        ...state,
        isPending: true
      }

    case 'AANMELDING_ERROR':
      return {
        ...state,
        isPending: false
      }

    case 'AANMELDING_SUCCESS':

      let aanmeldingen = null
      if (action.normalizeAsVliegers) {
        aanmeldingen = action.aanmeldingen.sort((a, b) => a.vlieger.name.localeCompare(b.vlieger.name))
        aanmeldingen = { aanmeldingen: normalizeVliegers(aanmeldingen, action.default_vliegers) }
        aanmeldingen.sleepvliegers = aanmeldingen.aanmeldingen.filter(a => a.as_sleepvlieger)
      } else {
        aanmeldingen = normalizeAanmeldingen(action.aanmeldingen, action.registration_lists)
      }

      const n_instructors = aanmeldingen.aanmeldingen.filter(a => a.as_instructeur && a.aangemeld).length

      return {
        ...state,
        isPending: false,
        // only forward dag_id, used in dropdown of starts
        dag_id: action.normalizeAsVliegers ? action.dag_id : null,
        is_today: action.is_today,
        messages: action.messages,
        n_instructors,
        notities: action.notities,
        diensten: action.diensten,
        registration_lists: action.registration_lists,
        bevoegdheden: action.bevoegdheden,
        lastUpdated: new Date(),
        topmeteo: action.topmeteo,
        ...aanmeldingen
      }

    case 'SAVE_REGISTRATION_LISTS':
      return {
        ...state,
        registration_lists: action.registration_lists
      }

    case 'SAVE_AANMELD_MESSAGE':
      let newMessages = state.messages.filter(m => m.id !== action.message.id)
      if (action.action !== 'delete') newMessages = [action.message].concat(newMessages)
      return {
        ...state,
        messages: newMessages
      }

    case 'RESET_AANMELDING_STATE':
      return {
        ...aanmeldingenState
      }

    default:
      return state
  }
}

// Selectors
const selectVliegers = (state) => state.flights.vliegers
const selectAanmeldingen = (state) => state.aanmeldingen

export const selectAlleVliegers = createSelector(
  [selectVliegers, selectAanmeldingen],
  (vliegers, aanmeldingen) => {
    if (!aanmeldingen?.is_today) return vliegers
    return vliegers.map((vlieger) => {
      const aanmelding = aanmeldingen.aanmeldingen.find(
        (a) => a.id === vlieger.id
      )
      if (aanmelding) {
        return { ...vlieger, requires_authorisation: aanmelding.requires_authorisation}
      }
      return vlieger
    })
  }
)
